import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { cardShadow } from '../../constants/uiTokens';
import Txt from './Txt';

/**
 * WaCard — card de seção da /integrations, traduzido 1:1 do mockup da designer:
 * fundo branco, borda fina, raio 10, sombra sutil, header com ícone colorido +
 * título (16/700) + ação opcional à direita, descrição alinhada sob o título e
 * corpo que escurece (dim) quando a seção está desligada.
 */
export default function WaCard({ icon, title, description, action, dim = false, children, sx, bodySx }) {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '10px',
        boxShadow: cardShadow,
        p: { xs: 2, sm: 2.75 },
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        {icon}
        <Txt sx={{ flex: 1, minWidth: 0, fontSize: 16, fontWeight: 700, color: 'text.primary', lineHeight: 1.3 }}>
          {title}
        </Txt>
        {action}
      </Box>

      {description && (
        <Txt sx={{ mt: 0.5, ml: '34px', fontSize: 13, color: 'text.secondary', lineHeight: 1.5 }}>
          {description}
        </Txt>
      )}

      {children != null && (
        <Box
          sx={{
            mt: 2,
            ...(dim ? { opacity: 0.45, pointerEvents: 'none', transition: 'opacity .15s' } : {}),
            ...bodySx,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

WaCard.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
  dim: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.object,
  bodySx: PropTypes.object,
};
